'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-env browser */
var prev = window.pageYOffset;
var up = null;
var down = null;
var wasUp = null;
var wasDown = null;
var position = 0;

function dispatch() {
  // eslint-disable-next-line no-shadow
  var position = window.pageYOffset;
  if (position > prev) {
    down = true;
    up = false;
  } else if (position < prev) {
    down = false;
    up = true;
  } else {
    up = null;
    down = null;
  }
  prev = position;
  document.dispatchEvent(new CustomEvent('theme:scroll', {
    detail: {
      up: up,
      down: down,
      position: position
    },
    bubbles: false
  }));
  if (up && !wasUp) {
    document.dispatchEvent(new CustomEvent('theme:scroll:up', {
      detail: { position: position },
      bubbles: false
    }));
  }
  if (down && !wasDown) {
    document.dispatchEvent(new CustomEvent('theme:scroll:down', {
      detail: { position: position },
      bubbles: false
    }));
  }
  wasDown = down;
  wasUp = up;
}

function lock() {
  position = window.pageYOffset;

  document.documentElement.style.setProperty('scroll-behavior', 'unset');
  document.body.style.setProperty('position', 'fixed');
  document.body.style.setProperty('top', '-' + position + 'px');
  document.body.style.setProperty('left', '0');
  document.body.style.setProperty('width', '100%');
  document.body.style.setProperty('overflow', 'hidden');

  document.documentElement.setAttribute('data-scroll-locked', '');
  document.documentElement.style.setProperty('position', 'relative');
  document.documentElement.style.setProperty('overflow', 'hidden');
}

function unlock() {
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('left');
  document.body.style.removeProperty('width');
  document.body.style.removeProperty('height');
  document.body.style.removeProperty('overflow');

  document.documentElement.removeAttribute('data-scroll-locked');
  document.documentElement.style.removeProperty('position');
  document.documentElement.style.removeProperty('overflow');

  window.scroll({
    left: 0,
    top: position
  });

  document.documentElement.style.setProperty('scroll-behavior', 'smooth');
}

function scrollListener() {
  var timeout = void 0;
  window.addEventListener('scroll', function () {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }
    timeout = window.requestAnimationFrame(function () {
      dispatch();
    });
  }, { passive: true });

  window.addEventListener('theme:scroll:lock', lock);
  window.addEventListener('theme:scroll:unlock', unlock);
}

exports.default = scrollListener;